import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_TRADING_GROUPS_BASE = "/admin/trading-groups";

export async function getTradingGroups() {

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.get(API_TRADING_GROUPS_BASE, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const TradingGroupsService = {
  getTradingGroups,
};

export default TradingGroupsService;
